import { useEffect, useState, useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'HkWrkStnName', label: 'Work Station', minWidth: 70 },
    { id: 'Abrv', label: 'Abbrivation', minWidth: 70 },
    { id: 'Remark', label: 'Remark', minWidth: 70 },
];

const WorkStation = () => {
    const [formData, setFormData] = useState({
        HkWrkStnName: '',
        Abrv: '',
        Remark: '',
    });

    const [error, setError] = useState({
        HkWrkStnName: false,
        Abrv: false,
    });

    const navigate = useNavigate();
    const location = useLocation();

    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [currentWorkStn, setCurrentWorkStn] = useState(null);
    const [mode, setMode] = useState('view');
    const [status, setStatus] = useState("1");
    const [lastInsertedHkWrkStnId, setLastInsertedHkWrkStnId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [userId] = useState(sessionStorage.getItem('UserId'));
    const [dataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);

    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const hkWrkStnNameRef = useRef(null);
    const abrvRef = useRef(null);
    const remarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.HkWrkStnId) {
            setCurrentWorkStn(location.state.HkWrkStnId);
            fetchWorkData(location.state.HkWrkStnId, "R");
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchWorkData = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstHkWrkStn/RetriveMstHkWrkStn`, {
                HkWrkStnId: parseInt(id),
                Flag: flag,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const workData = response.data.Data[0];
                setFormData({
                    HkWrkStnName: workData.HkWrkStnName || '',
                    Abrv: workData.Abrv || '',
                    Remark: workData.Remark || '',
                });
                setStatus(workData.status?.toString() || "1");
                setIsFormDisabled(true);
                setCurrentWorkStn(workData.HkWrkStnId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                console.error(response.data.Message);
            } else {
                console.error(response.data.Message || 'No record Found.');
            }
        } catch (error) {
            toast.error('Error while fetching work station.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 0,
                PageSize: 7,
                SearchText: "",
            };
            try {
                const res = await axiosInstance.post('MstHkWrkStn/getMstHkWrkStnDashBoard', { params });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                toast.error('Error fetching data:', err);
            }
        };
        getRow();
    }, []);

    const handlePrevious = async () => {
        if (currentWorkStn && currentWorkStn > 1) {
            await fetchWorkData(currentWorkStn, "P");
        }
    };

    const handleNext = async () => {
        if (currentWorkStn) {
            await fetchWorkData(currentWorkStn, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === hkWrkStnNameRef.current) {
                abrvRef.current.focus();
            } else if (event.target === abrvRef.current) {
                remarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {
        let hasError = false;

        if (!formData.HkWrkStnName) {
            toast.error('Work Station is required');
            setError((prev) => ({ ...prev, HkWrkStnName: true }));
            hasError = true;
        } else {
            setError((prev) => ({ ...prev, HkWrkStnName: false }));
        }

        if (hasError) return;

        try {
            const payload = {
                HkWrkStnName: formData.HkWrkStnName,
                Abrv: formData.Abrv,
                Remark: formData.Remark,
                status: status,
            };

            let response;
            if (mode === 'edit') {
                payload.HkWrkStnId = currentWorkStn;
                payload.UpdatedBy = parseInt(userId, 7);
                response = await axiosInstance.patch(`MstHkWrkStn/UpdateMstHkWrkStn`, payload);
            } else {
                payload.CreatedBy = parseInt(userId, 7);
                response = await axiosInstance.post(`MstHkWrkStn/InsertMstHkWrkStn`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedHkWrkStnId(response.data.Data);
                    await fetchWorkData(response.data.Data, "R");
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentWorkStn(response.data.Data);
                } else {
                    setMode('view');
                    setIsFormDisabled(true);
                    await UnLock(currentWorkStn, "MstHkWrkStn", "HkWrkStnId");
                }
            } else {
                console.error(response.data.Message || 'No record found.');
            }
        } catch (error) {
            toast.error('Error while saving work station.');
        }
    };

    const handleEdit = async () => {
        let flag = await checkAndLock(currentWorkStn, "MstHkWrkStn", "HkWrkStnId");
        switch (flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked.", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock.", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong.", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            HkWrkStnName: '',
            Abrv: '',
            Remark: '',
        });
        setCurrentWorkStn(null);
        setStatus("1");

        setTimeout(() => {
            hkWrkStnNameRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchWorkData(1, "L");
            await UnLock(currentWorkStn, "MstHkWrkStn", "HkWrkStnId");
            setStatus("1");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const handleExit = () => {
        navigate('/workstationtable');
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        const flag = await checkAndLock(currentWorkStn, "MstHkWrkStn", "HkWrkStnId");
        switch (flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchWorkData(currentWorkStn, "D");
                await fetchWorkData(1, "N");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
                toast.success("Record deleted successfully.");
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container"
                sx={{
                    width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                    maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                    height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "92vh" },
                    // height: { xs: '700px', sm: '550px' },
                    overflowX: "hidden",
                    overflowY: { xs: "auto", sm: "hidden", md: "hidden", lg: "hidden" },
                }}
            >
                <ToastContainer
                    position="top-center"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    transition={Slide}
                />
                <Grid container spacing={1} className="form_grid">
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '7px', sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '7px' }, display: 'block' }}
                                disabled={mode !== 'view' || !currentWorkStn || currentWorkStn === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: 'block' }}
                                disabled={mode !== 'view' || !currentWorkStn}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' },
                            }}
                        >
                            Work Station
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName="Work Station"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12} md={8} lg={8}>
                                <TextField
                                    id="HkWrkStnName"
                                    name="HkWrkStnName"
                                    label={
                                        <span>
                                            Work Station <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.HkWrkStnName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.HkWrkStnName}
                                    helperText={error.HkWrkStnName && ""}
                                    inputRef={hkWrkStnNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={8} lg={8}>
                                <TextField
                                    id="Abrv"
                                    name="Abrv"
                                    label="Abbrivation/Code"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Abrv}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={abrvRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12} md={5} lg={6}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={2}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }}
                                    onClick={handleAdd}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }}
                                    onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{
                                    mr: 1,
                                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                                }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(dataForPrint).length > 0 && (
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Work Station"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: '#f5f5f5' }}
                    />
                )}
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default WorkStation;
